namespace Gamification.Gamification {
    export interface EstensioniForm {
        Nome: Serenity.StringEditor;
        Estensione: Serenity.StringEditor;
        IdTipologiaRisorsa: Serenity.LookupEditor;
    }

    export class EstensioniForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.Estensioni';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EstensioniForm.init)  {
                EstensioniForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(EstensioniForm, [
                    'Nome', w0,
                    'Estensione', w0,
                    'IdTipologiaRisorsa', w1
                ]);
            }
        }
    }
}
